/* Contactos UI – Versión Premium para Presentación */
import React from "react";
import { QrCode } from "lucide-react";

const ContactosUI = ({ t, contactInfo, socialLinks }) => {
  return (
    <section className="min-h-screen bg-gradient-to-b from-white to-gray-100 py-24 px-6">
      <div className="max-w-7xl mx-auto">

        {/* TITULO */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-extrabold text-gray-900 tracking-tight">
            {t.contactTitle}
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mt-4 rounded-full" />
        </div>

        {/* CONTACTO + MAPA */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-24">

          {/* TARJETAS DE CONTACTO */}
          <div className="space-y-6">
            {contactInfo.map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl p-7 shadow-lg hover:shadow-xl transition border border-gray-200"
              >
                <div className="flex items-start gap-6">
                  {/* Ícono */}
                  <div className="p-4 bg-blue-700 text-white rounded-xl shadow-md">
                    {React.cloneElement(item.icon, {
                      className: "w-8 h-8"
                    })}
                  </div>

                  {/* Contenido */}
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-gray-700 text-sm leading-relaxed">
                      {item.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* MAPA */}
          <div className="lg:col-span-2 rounded-2xl shadow-xl border border-gray-200 overflow-hidden h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d498.7239407635828!2d-78.49039777311624!3d-0.2099819623676055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x91d59b577bc46049%3A0x42f5b4b580f52ed5!2sGrupo%20de%20investigaci%C3%B3n%20ATA-EPN%2C%20Laboratorio%20de%20UAVs!5e0!3m2!1ses!2sec!4v1743509042380!5m2!1ses!2ec"
              
              title="ATA Research Group – EPN Campus Map"
              loading="lazy"
              className="w-full h-full border-0"
            />
          </div>
        </div>

        {/* QR + REDES SOCIALES */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

          {/* QR */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border border-gray-200">
            <div className="flex items-center justify-center mb-8">
              <QrCode className="w-10 h-10 text-blue-700 mr-3" />
              <h3 className="text-2xl font-bold">{t.contactQr}</h3>
            </div>

            <div className="flex justify-center">
              <div className="relative group">
                <div className="absolute -inset-3 bg-blue-700 rounded-2xl blur-xl opacity-20 group-hover:opacity-40 transition"></div>
                <img
                  src="/images/qr_info1.png"
                  alt="QR"
                  className="relative w-64 rounded-xl shadow-md"
                />
              </div>
            </div>
          </div>

          {/* REDES SOCIALES */}
          <div className="bg-white rounded-2xl p-10 shadow-xl border border-gray-200">
            <h3 className="text-2xl font-bold text-center mb-10">
              {t.followUs}
            </h3>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 justify-items-center">
              {socialLinks.map((social, idx) => (
                <a
                  key={idx}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-center w-20 h-20 bg-white border border-gray-200 rounded-full shadow-md hover:shadow-xl transition-transform hover:scale-110"
                >
                  {React.cloneElement(social.icon, {
                    className:
                      "w-8 h-8 text-gray-700 group-hover:text-blue-700 transition"
                  })}
                </a>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ContactosUI;
